export const calculateProductMaxAmount = (redeem_limit, supply_limit, issued_counter, redeemed_count, available_amount) => {

  return Math.min(
    available_amount ?? Infinity,
    supply_limit ? supply_limit - issued_counter : Infinity,
    redeem_limit ? redeem_limit - redeemed_count : Infinity
  );
};

// Line-level max for a (product, variant) pair. Variant stock (SELL06) is the
// only supply grain for variant products — product-level supply_limit is
// ignored for them. The redeem limit stays product-level across variants, so
// callers pass amountInCartElsewhere: the quantity of the SAME product already
// held on OTHER cart lines (other SKUs), which consumes the shared allowance.
export const calculateLineMaxAmount = (product, variant, amountInCartElsewhere = 0) => {
  const redeemedCount = (product.redeemed_count || 0) + amountInCartElsewhere;
  if (variant) {
    return calculateProductMaxAmount(
      product.redeem_limit, null, null, redeemedCount, variant.available_amount
    );
  }
  return calculateProductMaxAmount(
    product.redeem_limit, product.supply_limit, product.issued_counter,
    redeemedCount, product.available_amount
  );
};
